export default "__VITE_ASSET__d3ef1b37__"